export default __webpack_public_path__ + "static/media/delete-icon.01333c2c.svg";